/*=========================================================================================
  File Name: moduleSpace.js
  Description: Space Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleNoticeBoardState.js'
import mutations from './moduleNoticeBoardMutations.js'
import actions from './moduleNoticeBoardActions.js'
import getters from './moduleNoticeBoardGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
